import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import DetailsWrapper from '../Details/DetailsWrapper';
import { MediaSlides } from './types';
import { useState, useEffect } from 'react';
import { mapByRefValue } from '../Details/Details';
import { _tekmirioFiles } from '../../lib/static/oa/tekmirio/details';
import { mapOmekaMediaMetadata } from '../../pages/ΟΑ/Tekmirio/helperFunctions';
import MediaSlider from '../../components/Carousel/MediaSlider';

interface ICarouselContainerForDetails {
    media: MediaSlides[];
    fileInfo?: any[];
}

const CarouselContainerWithMetadata = ({ media, fileInfo }: ICarouselContainerForDetails) => {
  const [mediaIndicator, setMediaIndicator] = useState<number | undefined>
  (media[0].mediaId);
  const [selectedMediaMetadata, setSelectedMediaMetadata] = useState<any[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    const _selectedMediaMetadata = mapOmekaMediaMetadata(fileInfo, mediaIndicator);
    const detailsFormatTransform = mapByRefValue(_selectedMediaMetadata, _tekmirioFiles);
    setSelectedMediaMetadata(detailsFormatTransform);    
  }, [mediaIndicator]);
    
  return (
    <>
      <Box display='flex' 
        flexDirection={{xs: 'column', lg: 'row'}}
        mt={3}
        sx={{columnGap: '50px'}}>
        <Box mb={'130px'}>
          {media.length > 0 &&
          <Box 
            sx={{
              height: '500px',
              margin: '0 auto',
            }}
          >
            <MediaSlider slides={[...media]} 
              setMediaIndicator={setMediaIndicator} 
              mediaIndicator={mediaIndicator}/>
          </Box>
          }
        </Box>
        <DetailsWrapper
          title={t('Λεπτομέρειες Αρχείου')}
          detailsProps={{
            rows: selectedMediaMetadata.map((x: any)=>{
              
              return {
                ...x, name: t(x.name)
              };
            }),
            removeLines: true
          }}
          defaultStyle
        />
      </Box>
    </>
  );
};

export default CarouselContainerWithMetadata;